module.exports = __webpack_public_path__ + "images/14-03_54f2d8d5.jpg";